import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAccessToken } from "src/utils/token-service";
import "./CompareCluster.css";

// Define types for clusters and tags
interface Tag {
  tagname: string;
  tagID: string;
}

interface Cluster {
  cluster_id: string;
  parent_intent: string;
  cluster_name: string;
  tags: Tag[];
  cluster_created_at: string;
  cluster_updated_at: string | null;
  is_cluster_verified: boolean;
  is_cluster_active: boolean;
  is_suggestion_cluster: boolean;
}

interface DraggedTag {
  tag: Tag;
  sourceCluster: string;
}

const newCluster: Cluster = {
  cluster_id: "new_cluster",
  parent_intent: "Billing",
  cluster_name: "New cluster",
  tags: [],
  cluster_created_at: new Date().toISOString(),
  cluster_updated_at: null,
  is_cluster_verified: false,
  is_cluster_active: true,
  is_suggestion_cluster: false
};

const CompareCluster: React.FC = () => {
  const location = useLocation();
  const selectedClusters: Cluster[] = (location?.state?.selectedClusters || []).concat(newCluster);
  const [clusters, setClusters] = useState<Cluster[]>(selectedClusters);
  const [draggedTag, setDraggedTag] = useState<DraggedTag | null>(null);
  const [movedTags, setMovedTags] = useState<{ cluster_id: string; tagID: string[] }[]>([]);
  const [newClusterName, setNewClusterName] = useState<string | null>(null);
  const { parentId, mappingType } = location?.state
  const navigate = useNavigate();

  console.log(parentId, mappingType)
  //const selectedClustersIds: Cluster[] = location?.state?.selectedClusters
  const selectedClustersIds = selectedClusters.map((cluster) => cluster.cluster_id).filter(id => id != "new_cluster")
  console.log("array:", selectedClustersIds)

  const handleCancel = () => {
    console.log("finalMovedTags", movedTags);
    navigate("/opportunity-analytics/cluster-manager");
  };

  const handleDrop = (targetCluster: string) => {
    if (!draggedTag) return;
    var tempnewName=''
    if (targetCluster === "new_cluster" && !newClusterName) {
      const enteredName = prompt("Enter a name for the new cluster:");
      
      if (!enteredName) return;
      tempnewName = enteredName
      setNewClusterName(enteredName);
      setClusters((prevClusters) =>
        prevClusters.map((cluster) =>
          cluster.cluster_id === "new_cluster" ? { ...cluster, cluster_name: enteredName } : cluster
        )
      );
    }

    setClusters((prevClusters) =>
      prevClusters.map((cluster) => {
        if (cluster.cluster_id === draggedTag.sourceCluster) {
          return {
            ...cluster,
            tags: cluster.tags.filter((tag) => tag.tagID !== draggedTag.tag.tagID),
          };
        }
        if (cluster.cluster_id === targetCluster) {
          return {
            ...cluster,
            tags: [...cluster.tags, draggedTag.tag],
          };
        }
        return cluster;
      })
    );

    setMovedTags((prev) => {
      let updatedTags = prev.map((entry) => ({
        ...entry,
        tagID: entry.tagID.filter((id) => id !== draggedTag.tag.tagID),
      })).filter((entry) => entry.tagID.length > 0);

      const isTagInOriginalCluster = selectedClusters.some(
        (cluster) =>
          cluster.cluster_id === targetCluster &&
          cluster.tags.some((tag) => tag.tagID === draggedTag.tag.tagID)
      );

      if (isTagInOriginalCluster) {
        return updatedTags;
      }

      const existingEntry = updatedTags.find((entry) => entry.cluster_id === targetCluster);
      if (existingEntry) {
        return updatedTags.map((entry) =>
          entry.cluster_id === targetCluster
            ? { ...entry, tagID: [...new Set([...entry.tagID, draggedTag.tag.tagID])] }
            : entry
        );
      } else {
        return [...updatedTags, { cluster_id: targetCluster, tagID: [draggedTag.tag.tagID] }];
      }
    });

    if (tempnewName!='') {
      setMovedTags((prev) =>
        prev.map((entry) =>
          entry.cluster_id === "new_cluster" ? { ...entry, cluster_name: tempnewName } : entry
        )
      );
      console.log("hi")
    }
    console.log("hello")
    console.log("entered new clustername: ", tempnewName)

    setDraggedTag(null);
  };

  const handleSave = async () => {
    const accessToken = await getAccessToken();
    const payload = {
      parent_id: parentId,
      mapping_type: mappingType,
      mappings: movedTags,
      selected_cluster_ids: selectedClustersIds
    };

    try {
      const response = await fetch("https://api-dv.brightspeed.com/genai-oa-service/update_tag_mapping", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Save successful:", data);
      alert("Clusters saved successfully!");

      //navigate("/opportunity-analytics/cluster-manager");
    } catch (error) {
      console.error("Error saving clusters:", error);
      alert("Failed to save clusters. Please try again.");
    }
    navigate("/opportunity-analytics/cluster-manager");

  };


  const handleDragStart = (tag: Tag, sourceCluster: string) => {
    setDraggedTag({ tag, sourceCluster });
  };

  return (
    <div className="container">
      <h2 className="title">Cluster Compare</h2>
      <div className="grid-container">
        {clusters.map((cluster) => (
          <ClusterColumn
            key={cluster.cluster_id}
            cluster={cluster}
            tags={cluster.tags}
            onDrop={() => handleDrop(cluster.cluster_id)}
            onDragStart={handleDragStart}
          />
        ))}
      </div>
      <div className="button-container">
        <button className="save-button" onClick={handleSave}>Save</button>
        <button className="cancel-button" onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  );
};

interface ClusterColumnProps {
  cluster: Cluster;
  tags: Tag[];
  onDrop: () => void;
  onDragStart: (tag: Tag, sourceCluster: string) => void;
}

const ClusterColumn: React.FC<ClusterColumnProps> = ({ cluster, tags, onDrop, onDragStart }) => {
  return (
    <div className="cluster-column" onDragOver={(e) => e.preventDefault()} onDrop={onDrop}>
      <h3 className="cluster-title">{cluster.cluster_name}</h3>
      <div className="tag-container">
        {tags.map((tag) => (
          <DraggableTag key={tag.tagID} tag={tag} cluster={cluster.cluster_id} onDragStart={onDragStart} />
        ))}
      </div>
    </div>
  );
};

interface DraggableTagProps {
  tag: Tag;
  cluster: string;
  onDragStart: (tag: Tag, sourceCluster: string) => void;
}

const DraggableTag: React.FC<DraggableTagProps> = ({ tag, cluster, onDragStart }) => {
  return (
    <div draggable onDragStart={() => onDragStart(tag, cluster)} className="draggable-tag">
      {tag.tagname}
    </div>
  );
};

export default CompareCluster;
